export const isFileSizeValid = (file: File, size: number): boolean => {
  if (size && file.size > size) {
    return false;
  }
  return true;
};

export const isFileAllowed = (file: File, accept: string): boolean => {
  if (file.type && accept.includes(file.type)) {
    return true;
  }
  const fileExtension = file.name.split('.').pop();
  if (fileExtension && accept.includes(`.${fileExtension}`)) {
    return true;
  }
  return false;
};

export const isValidEmail = (email: string): boolean => (
  !!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.exec(email.toLowerCase())
);

export const isValidPhoneNumber = (phone: string): boolean => !!/^[\d ().+]*$/.exec(phone);

export const isRelativeUrl = (url: string): boolean => {
  if (!url.startsWith('/') || url.startsWith('//')) {
    return false;
  }
  try {
    const parsed = new URL(url, 'https://placeholder.invalid');
    return parsed.hostname === 'placeholder.invalid';
  } catch {
    return false;
  }
};

export const isSameOriginUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.origin === window.location.origin;
  } catch {
    return false;
  }
};

const ALLOWED_ALEXA_REDIRECT_ORIGINS = new Set([
  'https://pitangui.amazon.com',
  'https://layla.amazon.com',
  'https://alexa.amazon.co.jp',
]);

export const isAllowedAlexaRedirectUrl = (url: string): boolean => {
  try {
    return ALLOWED_ALEXA_REDIRECT_ORIGINS.has(new URL(url).origin);
  } catch {
    return false;
  }
};
